import { LanguageSelectorSC, LanguageDisplaySC } from "../styles";
import SelectDropDown from "components/atomics/SelectDropDown";
import { useRecoilState } from "recoil";
import { languageAtom } from "translations/recoilState";
import { SelectChangeEvent } from "@mui/material";
import translations from "translations";
import { DE, GB, ES } from "country-flag-icons/react/3x2";
interface LanguageSelectorProps {
  hideBorder?: boolean;
  hideValue?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = (props) => {
  const [currentLanguage, setCurrentLanguage] = useRecoilState(languageAtom);
  const handleChange = (e: SelectChangeEvent<string>) => {
    setCurrentLanguage(e.target.value);
    translations.setLanguage(e.target.value.toLowerCase());
  };

  const options = [
    {
      label: (
        <>
          <DE style={{ paddingRight: "5px", height: "15px" }} title="DE" /> <span>DE</span>
        </>
      ),
      value: "DE",
    },
    {
      label: (
        <>
          <GB style={{ paddingRight: "5px", height: "15px" }} title="EN" /> <span>EN</span>
        </>
      ),
      value: "EN",
    },
    {
      label: (
        <>
          <ES style={{ paddingRight: "5px", height: "15px" }} title="ES" /> <span>ES</span>
        </>
      ),
      value: "ES",
    },
  ];
  return (
    <LanguageSelectorSC>
      <SelectDropDown
        value={currentLanguage.toUpperCase()}
        options={options}
        handleChange={handleChange}
        hideValue={props.hideValue}
        hideBorder={props.hideBorder}
      />
      <LanguageDisplaySC>{currentLanguage}</LanguageDisplaySC>
    </LanguageSelectorSC>
  );
};

export default LanguageSelector;
